module.exports = "<p>\r\n  pill-group works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/pill-group/pill-group.component.html
// module id = ./src/app/features/tabination/pill-group/pill-group.component.html
// module chunks = main